<template>
  <div class="results-card">

    <!-- Tabs + ações globais -->
    <div class="results-tabs-wrapper">
      <v-tabs
          v-model="abaAtiva"
          background-color="transparent"
          color="#023449"
          slider-color="#023449"
          class="results-tabs"
      >
        <v-tab v-if="dadosVendedores.length > 0" class="results-tab">
          <v-icon small class="mr-2">mdi-account-cash</v-icon>
          Vendedores
          <span class="tab-count">{{ dadosVendedores.length }}</span>
        </v-tab>
        <v-tab v-if="convenios.length > 0" class="results-tab">
          <v-icon small class="mr-2">mdi-handshake</v-icon>
          Convênios
          <span class="tab-count">{{ convenios.length }}</span>
        </v-tab>
        <v-tab v-if="dadosMotoristas.length > 0" class="results-tab">
          <v-icon small class="mr-2">mdi-truck-fast</v-icon>
          Motoristas
          <span class="tab-count">{{ dadosMotoristas.length }}</span>
        </v-tab>
      </v-tabs>

      <!-- Ações globais — apenas botões de exportação -->
      <div class="tabs-acoes-globais">
        <v-btn v-if="arquivoBase64" small class="btn-txt" @click="baixarTxt">
          <v-icon small class="mr-1">mdi-file-document-outline</v-icon>ARQUIVO TXT
        </v-btn>
        <ExcelExporter
            :dados="todosOsDados"
            :bonificacoes="bonificacoesVendedores"
            :colunas-visiveis="colunasExcelVisiveis"
            :convenios="convenios"
            :motoristas="dadosMotoristas"
            :filename="`exportacao_senior_${dtmes.replace('-', '_')}`"
            label="Excel"
            tipo="completo"
            :mostrar-comissao-base="mostrarComissaoBase"
            @success="$emit('export-success', $event)"
            @error="$emit('export-error', $event)"
            small
            class="btn-excel-wrap"
        />
      </div>
    </div>

    <!-- Meta-bar: badges de data/hora fora da barra de tabs -->
    <div v-if="ultimaChamadaFormatada" class="meta-bar">
      <div v-if="ultimaChamadaFormatada" class="meta-badge meta-badge-geracao">
        <span class="meta-dot meta-dot-blue"></span>
        <span class="meta-label">Relatório gerado em</span>
        <span class="meta-valor">{{ ultimaChamadaFormatada }}</span>
      </div>
    </div>

    <v-divider />

    <v-tabs-items v-model="abaAtiva">

      <!-- ════════════════════════════════════════
           ABA: VENDEDORES
      ════════════════════════════════════════ -->
      <v-tab-item v-if="dadosVendedores.length > 0">
        <div class="table-toolbar">
          <div class="d-flex align-center">
            <span class="table-title">{{ tituloTabelaVendedores }}</span>
            <span class="table-count ml-2">{{ dadosVendedores.length }} registros</span>
          </div>

          <!-- Seletor de colunas — único controle desta toolbar -->
          <v-menu
              v-model="menuColunasAberto"
              :close-on-content-click="false"
              offset-y left nudge-bottom="4" min-width="260"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" small outlined color="#023449" class="btn-colunas">
                <v-icon small class="mr-1">mdi-table-column</v-icon>
                Colunas
                <v-badge v-if="colunasOcultasCount > 0" :content="colunasOcultasCount" color="#023449" inline class="ml-1" />
              </v-btn>
            </template>

            <v-card class="colunas-menu-card" elevation="4">
              <div class="colunas-menu-header">
                <v-icon small class="mr-2" color="white">mdi-table-column</v-icon>
                <span>Colunas visíveis</span>
                <v-spacer />
                <v-btn x-small text color="#023449" @click="restaurarColunas" class="btn-restaurar">Restaurar</v-btn>
              </div>
              <v-divider />

              <template v-if="mostrarComissaoBase">
                <div class="colunas-grupo-label"><v-icon x-small class="mr-1" color="#475569">mdi-cart-outline</v-icon>Vendas</div>
                <div v-for="col in colunasGrupo1" :key="col.key" class="coluna-item">
                  <v-switch v-model="colunasVisiveis[col.key]" :label="col.label" dense hide-details color="#023449" class="coluna-switch" />
                </div>
                <v-divider class="my-1" />

                <div class="colunas-grupo-label"><v-icon x-small class="mr-1" color="#475569">mdi-chart-arc</v-icon>KPIs de Comissão</div>
                <div v-for="col in colunasGrupo2" :key="col.key" class="coluna-item">
                  <v-switch v-model="colunasVisiveis[col.key]" :label="col.label" dense hide-details color="#023449" class="coluna-switch" />
                </div>
                <v-divider class="my-1" />

                <div class="colunas-grupo-label"><v-icon x-small class="mr-1" color="#475569">mdi-cash-multiple</v-icon>Comissão</div>
                <div v-for="col in colunasGrupo3" :key="col.key" class="coluna-item">
                  <v-switch v-model="colunasVisiveis[col.key]" :label="col.label" dense hide-details color="#023449" class="coluna-switch" />
                </div>
                <v-divider class="my-1" />

                <div class="colunas-grupo-label"><v-icon x-small class="mr-1" color="#475569">mdi-sigma</v-icon>Salário</div>
                <div v-for="col in colunasGrupo4" :key="col.key" class="coluna-item">
                  <v-switch v-model="colunasVisiveis[col.key]" :label="col.label" dense hide-details color="#023449" class="coluna-switch" />
                </div>
                <v-divider class="my-1" />

                <div class="colunas-grupo-label"><v-icon x-small class="mr-1" color="#475569">mdi-file-export-outline</v-icon>Arquivo</div>
                <div v-for="col in colunasGrupo5" :key="col.key" class="coluna-item">
                  <v-switch v-model="colunasVisiveis[col.key]" :label="col.label" dense hide-details color="#475569" class="coluna-switch" />
                </div>
              </template>
            </v-card>
          </v-menu>
        </div>
        <v-divider />
        <div style="overflow-x: auto;">
          <v-simple-table dense class="data-table">
            <thead>
            <tr v-if="mostrarComissaoBase && false">
              <th colspan="2" class="group-header-empty"></th>
              <th v-if="colunaGrupo1Count > 0" :colspan="colunaGrupo1Count" class="group-header gh-vendas">
                <v-icon x-small class="mr-1">mdi-cart-outline</v-icon>Vendas
              </th>
              <th v-if="colunaGrupo2Count > 0" :colspan="colunaGrupo2Count" class="group-header gh-percentuais">
                <v-icon x-small class="mr-1">mdi-chart-arc</v-icon>KPIs de Comissão
              </th>
              <th v-if="colunaGrupo3Count > 0" :colspan="colunaGrupo3Count" class="group-header gh-comissao">
                <v-icon x-small class="mr-1">mdi-cash-multiple</v-icon>Comissão
              </th>
              <th v-if="bonificacoesVendedores.length > 0" :colspan="bonificacoesVendedores.length * 2" class="group-header gh-bonif">
                <v-icon x-small class="mr-1">mdi-trophy</v-icon>Bonificações
              </th>
              <th v-if="colunasVisiveis.salariobase || colunasVisiveis.salario_proporcional"
                  :colspan="(colunasVisiveis.salariobase ? 1 : 0) + (colunasVisiveis.salario_proporcional ? 1 : 0)"
                  class="group-header gh-salario">
                <v-icon x-small class="mr-1">mdi-sigma</v-icon>Salário
              </th>
              <th v-if="colunasVisiveis.premiacao" colspan="1" class="group-header gh-exportado">
                <v-icon x-small class="mr-1">mdi-file-export-outline</v-icon>Arquivo
              </th>
            </tr>
            <tr>
              <th class="text-left col-first">Filial</th>
              <th class="text-left">CAD</th>
              <th class="text-left">Vendedor</th>
              <th v-if="mostrarComissaoBase && colunasVisiveis.meta" :class="['text-right', sepG(['meta','vendabase'], 'meta')]">Meta</th>
              <th v-if="mostrarComissaoBase && colunasVisiveis.vendabase" :class="['text-right', sepG(['meta','vendabase'], 'vendabase')]">Venda Base</th>
              <th v-if="mostrarComissaoBase && colunasVisiveis.permeta" :class="['text-right', sepG(['permeta','margem'], 'permeta')]">% Meta</th>
              <th v-if="mostrarComissaoBase && colunasVisiveis.margem" :class="['text-right', sepG(['permeta','margem'], 'margem')]">% Margem</th>
              <th v-if="mostrarComissaoBase && colunasVisiveis.percomissao" :class="['text-right', sepG(['percomissao','comissaobase'], 'percomissao')]">% Rendimento Var.</th>
              <th v-if="mostrarComissaoBase && colunasVisiveis.comissaobase" :class="['text-right', sepG(['percomissao','comissaobase'], 'comissaobase')]">Rendimento Var.</th>
              <template v-for="bonif in bonificacoesVendedores">
                <th :key="`th-venda-${bonif}`" class="text-right sep-left">
                  <div class="d-flex align-center justify-end">
                    Venda {{ bonif }}
                    <v-tooltip bottom max-width="280" color="#023449">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon x-small class="ml-1" style="color: #94a3b8;" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                      </template>
                      <div class="pa-1">
                        <div class="font-weight-bold text-body-2 mb-2">{{ getBonificacaoInfo(bonif).nome }}</div>
                        <div class="d-flex justify-space-between mb-1">
                          <span class="text-caption" style="color:#94a3b8;margin-right:16px">Percentual</span>
                          <span class="text-caption">{{ (getBonificacaoInfo(bonif).percentual * 100).toFixed(2) }}%</span>
                        </div>
                        <div class="d-flex justify-space-between">
                          <span class="text-caption" style="color:#94a3b8;margin-right:16px">Evento Senior</span>
                          <span class="text-caption">{{ getBonificacaoInfo(bonif).eventosenior }}</span>
                        </div>
                      </div>
                    </v-tooltip>
                  </div>
                </th>
                <th :key="`th-comissao-${bonif}`" class="text-right">Comissão {{ bonif }}</th>
              </template>
              <th v-if="mostrarComissaoBase && colunasVisiveis.salariobase" :class="['text-right', sepG(['salariobase','salario_proporcional'], 'salariobase')]">Salário Base</th>
              <th v-if="mostrarComissaoBase && colunasVisiveis.salario_proporcional" :class="['text-right', sepG(['salariobase','salario_proporcional'], 'salario_proporcional')]">Sal. Proporcional</th>
              <th v-if="mostrarComissaoBase && colunasVisiveis.premiacao" class="text-right sep-grupo">Premiação</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(u, i) in dadosVendedores" :key="i" class="data-row">
              <td class="col-first" style="color: #64748b;">{{ u.filial }}</td>
              <td class="font-weight-medium text-truncate" style="max-width: 200px;">{{ u.codsenior }}</td>
              <td class="font-weight-medium text-truncate" style="max-width: 200px;">{{ u.vendedor }}</td>
              <td v-if="mostrarComissaoBase && colunasVisiveis.meta" :class="['text-right', sepG(['meta','vendabase'], 'meta')]">{{ u.meta | formataDinheiro }}</td>
              <td v-if="mostrarComissaoBase && colunasVisiveis.vendabase" :class="['text-right', sepG(['meta','vendabase'], 'vendabase')]">{{ u.vendabase | formataDinheiro }}</td>
              <td v-if="mostrarComissaoBase && colunasVisiveis.permeta" :class="['text-right', sepG(['permeta','margem'], 'permeta')]">
                <span :class="getClassePermeta(u.permeta)">{{ u.permeta | formataPercentual }}</span>
              </td>
              <td v-if="mostrarComissaoBase && colunasVisiveis.margem" :class="['text-right', sepG(['permeta','margem'], 'margem')]">
                <span :class="getClasseMargem(u.margem)">{{ u.margem | formataPercentual }}</span>
              </td>
              <td v-if="mostrarComissaoBase && colunasVisiveis.percomissao" :class="['text-right', sepG(['percomissao','comissaobase'], 'percomissao')]">{{ u.percomissao | formataPercentual }}</td>
              <td v-if="mostrarComissaoBase && colunasVisiveis.comissaobase" :class="['text-right font-weight-medium', sepG(['percomissao','comissaobase'], 'comissaobase')]">{{ u.comissaobase | formataDinheiro }}</td>
              <template v-for="bonif in bonificacoesVendedores">
                <td :key="`td-venda-${bonif}-${i}`" class="text-right sep-left">
                  <span :class="getBonificacaoVenda(u, bonif) > 0 ? 'value-positive' : 'value-zero'">{{ getBonificacaoVenda(u, bonif) | formataDinheiro }}</span>
                </td>
                <td :key="`td-com-${bonif}-${i}`" class="text-right">
                  <span :class="getBonificacaoComissao(u, bonif) > 0 ? 'value-positive' : 'value-zero'">{{ getBonificacaoComissao(u, bonif) | formataDinheiro }}</span>
                </td>
              </template>
              <td v-if="mostrarComissaoBase && colunasVisiveis.salariobase" :class="['text-right', sepG(['salariobase','salario_proporcional'], 'salariobase')]">
                <v-chip v-if="!u.salariobase || u.salariobase === 0" x-small color="#fef3c7" text-color="#92400e" class="chip-alerta font-weight-bold">
                  <v-icon x-small left>mdi-alert-outline</v-icon>Não configurado
                </v-chip>
                <span v-else style="color: #64748b;">{{ u.salariobase | formataDinheiro }}</span>
              </td>
              <td v-if="mostrarComissaoBase && colunasVisiveis.salario_proporcional" :class="['text-right', sepG(['salariobase','salario_proporcional'], 'salario_proporcional')]">
                <span v-if="!u.salario_proporcional || u.salario_proporcional === 0" class="value-zero">—</span>
                <span v-else class="font-weight-bold" style="color: #023449;">{{ u.salario_proporcional | formataDinheiro }}</span>
              </td>
              <td v-if="mostrarComissaoBase && colunasVisiveis.premiacao" class="text-right sep-grupo">
                <span v-if="u.premiacao > 0" class="value-exported">{{ u.premiacao | formataDinheiro }}</span>
                <span v-else class="value-zero">—</span>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr class="data-footer">
              <td colspan="3" class="col-first">TOTAL GERAL</td>
              <td v-if="mostrarComissaoBase && colunasVisiveis.meta" :class="['text-right', sepG(['meta','vendabase'], 'meta')]">{{ somarCampo(dadosVendedores, 'meta') | formataDinheiro }}</td>
              <td v-if="mostrarComissaoBase && colunasVisiveis.vendabase" :class="['text-right', sepG(['meta','vendabase'], 'vendabase')]">{{ somarCampo(dadosVendedores, 'vendabase') | formataDinheiro }}</td>
              <td v-if="mostrarComissaoBase && colunasVisiveis.permeta" :class="['text-right', sepG(['permeta','margem'], 'permeta')]">{{ mediasCampo(dadosVendedores, 'permeta') | formataPercentual }}</td>
              <td v-if="mostrarComissaoBase && colunasVisiveis.margem" :class="['text-right', sepG(['permeta','margem'], 'margem')]">{{ mediasCampo(dadosVendedores, 'margem') | formataPercentual }}</td>
              <td v-if="mostrarComissaoBase && colunasVisiveis.percomissao" :class="['text-right', sepG(['percomissao','comissaobase'], 'percomissao')]">{{ mediasCampo(dadosVendedores, 'percomissao') | formataPercentual }}</td>
              <td v-if="mostrarComissaoBase && colunasVisiveis.comissaobase" :class="['text-right', sepG(['percomissao','comissaobase'], 'comissaobase')]">{{ somarCampo(dadosVendedores, 'comissaobase') | formataDinheiro }}</td>
              <template v-for="bonif in bonificacoesVendedores">
                <td :key="`tf-v-${bonif}`" class="text-right sep-left">{{ somarBonificacaoVenda(dadosVendedores, bonif) | formataDinheiro }}</td>
                <td :key="`tf-c-${bonif}`" class="text-right">{{ somarBonificacaoComissao(dadosVendedores, bonif) | formataDinheiro }}</td>
              </template>
              <td v-if="mostrarComissaoBase && colunasVisiveis.salariobase" :class="['text-right', sepG(['salariobase','salario_proporcional'], 'salariobase')]">{{ somarCampo(dadosVendedores, 'salariobase') | formataDinheiro }}</td>
              <td v-if="mostrarComissaoBase && colunasVisiveis.salario_proporcional" :class="['text-right', sepG(['salariobase','salario_proporcional'], 'salario_proporcional')]">{{ somarCampo(dadosVendedores, 'salario_proporcional') | formataDinheiro }}</td>
              <td v-if="mostrarComissaoBase && colunasVisiveis.premiacao" class="text-right sep-grupo">{{ somarCampo(dadosVendedores, 'premiacao') | formataDinheiro }}</td>
            </tr>
            </tfoot>
          </v-simple-table>
        </div>
      </v-tab-item>

      <!-- ════════════════════════════════════════
           ABA: CONVENIOS
      ════════════════════════════════════════ -->
      <v-tab-item v-if="convenios.length > 0">
        <div class="table-toolbar">
          <div class="d-flex align-center">
            <span class="table-title">Descontos de Convênios</span>
            <span class="table-count ml-2">{{ convenios.length }} registros</span>
          </div>
        </div>
        <v-divider />

        <!-- Totalizador de resumo -->
        <div class="convenios-resumo">
          <div class="resumo-item">
            <span class="resumo-label">Total de colaboradores</span>
            <span class="resumo-valor">{{ convenios.length }}</span>
          </div>
          <div class="resumo-divider"></div>
          <div class="resumo-item">
            <span class="resumo-label">Total de títulos</span>
            <span class="resumo-valor">{{ somarCampo(convenios, 'qtdtitulos') }}</span>
          </div>
          <div class="resumo-divider"></div>
          <div class="resumo-item">
            <span class="resumo-label">Total a descontar</span>
            <span class="resumo-valor resumo-valor-destaque">{{ somarCampo(convenios, 'totaldescontos') | formataDinheiro }}</span>
          </div>
        </div>

        <div style="overflow-x: auto;">
          <v-simple-table dense class="data-table">
            <thead>
            <tr>
              <th class="text-left col-first" style="width: 48px;"></th>
              <th class="text-left" style="width: 60px;">Filial</th>
              <th class="text-left">Colaborador</th>
              <th class="text-left">CPF</th>
              <th class="text-center">Títulos</th>
              <th class="text-right col-last">Total a Descontar</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(c, i) in convenios">
              <!-- Linha principal do colaborador -->
              <tr
                  :key="`conv-row-${i}`"
                  class="data-row convenio-row"
                  :class="{ 'convenio-row-expanded': expandidosConvenio[i] }"
                  @click="toggleConvenio(i)"
              >
                <td class="col-first text-center convenio-expand-cell">
                  <v-icon small :class="expandidosConvenio[i] ? 'icon-expanded' : 'icon-collapsed'" color="#94a3b8">
                    mdi-chevron-right
                  </v-icon>
                </td>
                <td style="color: #64748b;">{{ c.idfilial }}</td>
                <td class="font-weight-medium">{{ c.colaborador }}</td>
                <td style="color: #64748b; font-family: monospace; font-size: 12px;">{{ formatarCpf(c.cpfcolaborador) }}</td>
                <td class="text-center">
                  <v-chip x-small color="#e0f2fe" text-color="#0369a1" class="font-weight-bold">
                    {{ c.qtdtitulos }}
                  </v-chip>
                </td>
                <td class="text-right col-last font-weight-bold" style="color: #023449;">
                  {{ c.totaldescontos | formataDinheiro }}
                </td>
              </tr>

              <!-- Linha de detalhe — títulos expandidos -->
              <tr v-if="expandidosConvenio[i]" :key="`conv-detail-${i}`" class="convenio-detail-row">
                <td colspan="6" class="pa-0">
                  <div class="convenio-titulos-wrapper">
                    <div class="convenio-titulos-header">
                      <v-icon x-small class="mr-1" color="#0369a1">mdi-receipt-text-outline</v-icon>
                      Títulos em aberto — {{ c.colaborador }}
                    </div>
                    <v-simple-table dense class="titulos-table">
                      <thead>
                      <tr>
                        <th class="text-right" style="width: 80px;">Título</th>
                        <th class="text-left">Tipo</th>
                        <th class="text-center">Dt. Movimento</th>
                        <th class="text-center">Dt. Vencimento</th>
                        <th class="text-right">Saldo a Pagar</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(t, j) in c.titulos" :key="`titulo-${i}-${j}`" class="titulo-row">
                        <td class="text-right" style="color: #64748b; font-family: monospace; font-size: 12px;">
                          {{ t.titulo }}<span v-if="t.digito" style="color: #94a3b8;">-{{ t.digito }}</span>
                        </td>
                        <td>
                          <v-chip x-small color="primary" text-color="white" class="font-weight-medium">
                            {{ t.descrrecebimento }}
                          </v-chip>
                        </td>
                        <td class="text-center" style="color: #64748b; font-size: 12px;">{{ formatarData(t.dtmovimento) }}</td>
                        <td class="text-center" style="font-size: 12px;">
                          <span :class="getClasseVencimento(t.dtvencimento)">{{ formatarData(t.dtvencimento) }}</span>
                        </td>
                        <td class="text-right font-weight-medium" style="color: #dc2626;">
                          {{ t.valsaldopagar | formataDinheiro }}
                        </td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr class="titulo-footer">
                        <td colspan="4" class="text-right font-weight-bold" style="font-size: 12px;">Subtotal</td>
                        <td class="text-right font-weight-bold" style="color: #023449;">
                          {{ c.totaldescontos | formataDinheiro }}
                        </td>
                      </tr>
                      </tfoot>
                    </v-simple-table>
                  </div>
                </td>
              </tr>
            </template>
            </tbody>
            <tfoot>
            <tr class="data-footer">
              <td colspan="4" class="col-first">TOTAL GERAL</td>
              <td class="text-center">{{ somarCampo(convenios, 'qtdtitulos') }}</td>
              <td class="text-right col-last">{{ somarCampo(convenios, 'totaldescontos') | formataDinheiro }}</td>
            </tr>
            </tfoot>
          </v-simple-table>
        </div>
      </v-tab-item>

      <!-- ════════════════════════════════════════
           ABA: MOTORISTAS
      ════════════════════════════════════════ -->
      <v-tab-item v-if="dadosMotoristas.length > 0">
        <div class="table-toolbar">
          <div class="d-flex align-center">
            <span class="table-title">Bonificações de Motoristas</span>
            <span class="table-count ml-2">{{ dadosMotoristas.length }} registros</span>
          </div>
        </div>
        <v-divider />
        <div style="overflow-x: auto;">
          <v-simple-table dense class="data-table">
            <thead>
            <tr>
              <th class="text-left col-first">Filial</th>
              <th class="text-left">Motorista</th>
              <th class="text-center">Meta Entregas</th>
              <th class="text-center">Qtd Entregas</th>
              <th class="text-right">Valor/Entrega</th>
              <th class="text-right col-last">Bonificação</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(u, i) in dadosMotoristas" :key="i" class="data-row">
              <td class="col-first" style="color: #64748b;">{{ u.idfilial }}</td>
              <td class="font-weight-medium text-truncate" style="max-width: 200px;">{{ u.vendedor }}</td>
              <td class="text-center">{{ u.meta_entregas || 0 }}</td>
              <td class="text-center">
                <v-chip x-small :color="u.qtd_entregas >= u.meta_entregas ? 'success' : 'warning'" text-color="white" class="font-weight-medium">
                  {{ u.qtd_entregas || 0 }}
                </v-chip>
              </td>
              <td class="text-right">{{ u.valor_por_entrega | formataDinheiro }}</td>
              <td class="text-right font-weight-bold col-last" style="color: #023449;">{{ u.valor_bonificacao | formataDinheiro }}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr class="data-footer">
              <td colspan="2" class="col-first">TOTAL GERAL</td>
              <td class="text-center">{{ somarCampo(dadosMotoristas, 'meta_entregas') }}</td>
              <td class="text-center">{{ somarCampo(dadosMotoristas, 'qtd_entregas') }}</td>
              <td class="text-right">—</td>
              <td class="text-right col-last">{{ somarCampo(dadosMotoristas, 'valor_bonificacao') | formataDinheiro }}</td>
            </tr>
            </tfoot>
          </v-simple-table>
        </div>
      </v-tab-item>

    </v-tabs-items>
  </div>
</template>

<script>
import ExcelExporter from "../Widgets/ExcelExporter.vue";

const COLUNAS_BASE_DEFAULT = {
  meta:         true,
  vendabase:    true,
  comissaobase: true,
  salariobase:  true,
};

const COLUNAS_ANALISE_DEFAULT = {
  permeta:     false,
  margem:      false,
  percomissao: true,
};

const COLUNAS_TOTAIS_DEFAULT = {
  salario_proporcional:          true,
  premiacao: true,
};

export default {
  name: "ExportadorTabela",
  components: { ExcelExporter },

  props: {
    dados: {
      type: Array,
      default: () => [],
    },
    convenios: {
      type: Array,
      default: () => [],
    },
    dtmes: {
      type: String,
      default: '',
    },
    tiposComissaoSelecionados: {
      type: Array,
      default: () => [],
    },
    arquivoBase64: {
      type: String,
      default: null,
    },
    ultimaChamada: {
      type: Date,
      default: null,
    },
  },

  data() {
    return {
      abaAtiva: 0,
      menuColunasAberto: false,
      colunasVisiveis: {
        ...COLUNAS_BASE_DEFAULT,
        ...COLUNAS_ANALISE_DEFAULT,
        ...COLUNAS_TOTAIS_DEFAULT,
      },
      expandidosConvenio: {},
    };
  },

  computed: {
    dadosVendedores() {
      return this.dados.filter(d =>
          d.meta !== undefined || d.vendabase !== undefined ||
          d.comissaobase !== undefined || (d.bonificacoes && Object.keys(d.bonificacoes).length > 0)
      );
    },
    dadosMotoristas() {
      return this.dados.filter(d => d.meta_entregas !== undefined);
    },
    todosOsDados() {
      return this.dados;
    },

    mostrarComissaoBase() {
      return this.tiposComissaoSelecionados.includes('comissao_vendedores');
    },
    tituloTabelaVendedores() {
      return this.mostrarComissaoBase ? 'Comissões de Vendedores' : 'Bonificações de Vendedores';
    },

    bonificacoesVendedores() {
      const set = new Set();
      this.dadosVendedores.forEach(v => {
        if (v.bonificacoes) Object.keys(v.bonificacoes).forEach(c => set.add(c));
      });
      return Array.from(set).sort();
    },

    colunasGrupo1() { return [{ key: 'meta', label: 'Meta' }, { key: 'vendabase', label: 'Venda Base' }]; },
    colunasGrupo2() { return [{ key: 'permeta', label: '% Meta' }, { key: 'margem', label: '% Margem' }]; },
    colunasGrupo3() { return [{ key: 'percomissao', label: '% Rendimento Variável' }, { key: 'comissaobase', label: 'Rendimento Variável' }]; },
    colunasGrupo4() { return [{ key: 'salariobase', label: 'Salário Base' }, { key: 'salario_proporcional', label: 'Salário Proporcional' }]; },
    colunasGrupo5() { return [{ key: 'premiacao', label: 'Premiação' }]; },

    colunasOcultasCount() {
      const todas = [
        ...this.colunasGrupo1, ...this.colunasGrupo2,
        ...this.colunasGrupo3, ...this.colunasGrupo4, ...this.colunasGrupo5,
      ];
      return todas.filter(c => !this.colunasVisiveis[c.key]).length;
    },

    ultimaChamadaFormatada() {
      if (!this.ultimaChamada) return null;
      const d = this.ultimaChamada;
      const pad = n => String(n).padStart(2, '0');
      return `${pad(d.getDate())}/${pad(d.getMonth()+1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },

    colunasExcelVisiveis() {
      const campos = [];
      if (this.mostrarComissaoBase) {
        if (this.colunasVisiveis.meta)             campos.push({ key: 'meta',             label: 'Meta' });
        if (this.colunasVisiveis.vendabase)        campos.push({ key: 'vendabase',        label: 'Venda Base' });
        if (this.colunasVisiveis.permeta)          campos.push({ key: 'permeta',          label: '% Meta' });
        if (this.colunasVisiveis.margem)           campos.push({ key: 'margem',           label: '% Margem' });
        if (this.colunasVisiveis.percomissao)      campos.push({ key: 'percomissao',      label: '% Rendimento Variável' });
        if (this.colunasVisiveis.comissaobase)     campos.push({ key: 'comissaobase',     label: 'Rendimento Variável' });
        if (this.colunasVisiveis.salariobase)      campos.push({ key: 'salariobase',      label: 'Salário Base' });
        if (this.colunasVisiveis.salario_proporcional)          campos.push({ key: 'salario_proporcional',          label: 'Salário Proporcional' });
        if (this.colunasVisiveis.premiacao) campos.push({ key: 'premiacao', label: 'Premiação' });
      }
      return campos;
    },

    colunaGrupo1Count() { return !this.mostrarComissaoBase ? 0 : this.colunasGrupo1.filter(c => this.colunasVisiveis[c.key]).length; },
    colunaGrupo2Count() { return !this.mostrarComissaoBase ? 0 : this.colunasGrupo2.filter(c => this.colunasVisiveis[c.key]).length; },
    colunaGrupo3Count() { return !this.mostrarComissaoBase ? 0 : this.colunasGrupo3.filter(c => this.colunasVisiveis[c.key]).length; },
  },

  watch: {
    convenios() {
      this.expandidosConvenio = {};
    },
  },

  filters: {
    formataPercentual(v) {
      if (v === undefined || v === null) return '—';
      return Number(v).toFixed(2) + '%';
    },
  },

  methods: {
    baixarTxt() {
      if (!this.arquivoBase64) return;
      const d    = window.atob(this.arquivoBase64);
      const a    = new Uint8Array(d.length);
      for (let i = 0; i < d.length; i++) a[i] = d.charCodeAt(i);
      const blob = new Blob([a], { type: 'text/plain' });
      const url  = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href  = url;
      link.setAttribute('download', `exportacao_senior_${this.dtmes.replace('-', '_')}.txt`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },

    sepG(grupo, chaveAtual) {
      const primeiraVisivel = grupo.find(k => this.colunasVisiveis[k]);
      return primeiraVisivel === chaveAtual ? 'sep-grupo' : '';
    },

    restaurarColunas() {
      this.colunasVisiveis = {
        ...COLUNAS_BASE_DEFAULT,
        ...COLUNAS_ANALISE_DEFAULT,
        ...COLUNAS_TOTAIS_DEFAULT,
      };
    },

    getClassePermeta(v) {
      if (!v) return 'value-zero';
      if (v >= 100) return 'value-positive';
      if (v >= 75)  return 'value-warning';
      return 'value-negative';
    },

    getClasseMargem(v) {
      if (!v) return 'value-zero';
      if (v >= 26) return 'value-positive';
      if (v >= 22) return 'value-warning';
      return 'value-negative';
    },

    getBonificacaoVenda(v, c)    { return v.bonificacoes?.[c]?.vendatotal || 0; },
    getBonificacaoComissao(v, c) { return v.bonificacoes?.[c]?.comissao   || 0; },

    getBonificacaoInfo(c) {
      for (const v of this.dadosVendedores) {
        if (v.bonificacoes?.[c]) return {
          nome:         v.bonificacoes[c].nome || 'Bonificação',
          percentual:   v.bonificacoes[c].percentual || 0,
          eventosenior: v.bonificacoes[c].eventosenior || c,
        };
      }
      return { nome: 'Bonificação ' + c, percentual: 0, eventosenior: c };
    },

    somarCampo(dados, campo) {
      return dados.filter(v => v[campo] !== undefined).reduce((a, v) => a + (v[campo] || 0), 0);
    },

    mediasCampo(dados, campo) {
      const com = dados.filter(v => v[campo] !== undefined && v[campo] !== 0);
      if (!com.length) return 0;
      return com.reduce((a, v) => a + v[campo], 0) / com.length;
    },

    somarBonificacaoVenda(dados, c)    { return dados.reduce((t, v) => t + (v.bonificacoes?.[c]?.vendatotal || 0), 0); },
    somarBonificacaoComissao(dados, c) { return dados.reduce((t, v) => t + (v.bonificacoes?.[c]?.comissao   || 0), 0); },

    toggleConvenio(i) {
      this.$set(this.expandidosConvenio, i, !this.expandidosConvenio[i]);
    },

    formatarCpf(cpf) {
      if (!cpf) return '—';
      const s = String(cpf).replace(/\D/g, '').padStart(11, '0');
      return `${s.slice(0,3)}.${s.slice(3,6)}.${s.slice(6,9)}-${s.slice(9,11)}`;
    },

    formatarData(data) {
      if (!data) return '—';
      const s = String(data).slice(0, 10);
      const [y, m, d] = s.split('-');
      return `${d}/${m}/${y}`;
    },

    getClasseVencimento(data) {
      if (!data) return '';
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      const venc = new Date(String(data).slice(0, 10) + 'T00:00:00');
      const diff = (venc - hoje) / 86400000;
      if (diff < 0)  return 'venc-atrasado';
      if (diff <= 7) return 'venc-proximo';
      return 'venc-ok';
    },
  },
};
</script>

<style scoped>
/* ═══════════════════════════════════════════════════════
   VARIÁVEIS DE TEMA
═══════════════════════════════════════════════════════ */
.results-card {
  --brand:        #023449;
  --brand-mid:    #0a4d6a;
  --brand-light:  #e6eef2;

  --g1-bg: #f8fafc;  --g1-text: #475569;
  --g2-bg: #eef2ff;  --g2-text: #4338ca;
  --g3-bg: #fffbeb;  --g3-text: #b45309;
  --gb-bg: #ecfdf5;  --gb-text: #059669;
  --g4-bg: #f0f9ff;  --g4-text: #0369a1;
}

/* ═══════════════════════════════════════════════════════
   CARD CONTAINER
═══════════════════════════════════════════════════════ */
.results-card {
  background: #ffffff;
  border-radius: 14px;
  box-shadow:
      0 1px 3px rgba(2,52,73,0.06),
      0 8px 24px rgba(2,52,73,0.08),
      0 0 0 1px rgba(2,52,73,0.06);
  overflow: hidden;
  animation: fadeInUp 0.35s cubic-bezier(0.16,1,0.3,1);
}

/* ═══════════════════════════════════════════════════════
   BARRA DE TABS — apenas tabs + botões de exportação
═══════════════════════════════════════════════════════ */
.results-tabs-wrapper {
  display: flex;
  align-items: center;
  padding: 0 12px 0 0;
  background: linear-gradient(135deg, #023449 0%, #0a4d6a 100%);
  min-height: 48px;
}

.results-tabs {
  flex: 1;
  min-width: 0;
}

.tabs-acoes-globais {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding-left: 12px;
}

.results-tab {
  text-transform: none !important;
  letter-spacing: normal !important;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255,255,255,0.5) !important;
  min-width: 140px;
  transition: color 0.2s;
}

.results-tabs .v-tab--active { color: #ffffff !important; }

.results-tabs >>> .v-tabs-slider {
  background-color: #38bdf8 !important;
  height: 3px;
  border-radius: 3px 3px 0 0;
}

.tab-count {
  display: inline-flex; align-items: center; justify-content: center;
  background: rgba(255,255,255,0.12); color: rgba(255,255,255,0.6);
  font-size: 11px; font-weight: 700; border-radius: 20px;
  padding: 1px 7px; margin-left: 7px; min-width: 22px; transition: all 0.2s;
}

.v-tab--active .tab-count { background: rgba(56,189,248,0.3); color: #e0f5ff; }

/* ═══════════════════════════════════════════════════════
   META-BAR — badges de data/hora abaixo da barra de tabs
═══════════════════════════════════════════════════════ */
.meta-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 6px 16px;
  background: rgba(2, 52, 73, 0.03);
  border-bottom: 1px solid #e2eaf0;
  flex-wrap: wrap;
}

.meta-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  border: 1px solid;
  border-radius: 6px;
  padding: 3px 10px;
  white-space: nowrap;
}

.meta-badge-salario {
  background: rgba(251, 191, 36, 0.08);
  border-color: rgba(251, 191, 36, 0.35);
}

.meta-badge-salario .meta-valor { color: #92400e; }

.meta-badge-geracao {
  background: rgba(56, 189, 248, 0.08);
  border-color: rgba(56, 189, 248, 0.3);
}

.meta-badge-geracao .meta-valor { color: #075985; }

.meta-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.meta-dot-amber { background: #fbbf24; }
.meta-dot-blue  { background: #38bdf8; }

.meta-label { color: #64748b; font-weight: 500; }
.meta-valor { font-weight: 700; }

/* ═══════════════════════════════════════════════════════
   TOOLBAR DAS ABAS (título + controles locais)
═══════════════════════════════════════════════════════ */
.table-toolbar {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 20px; background: #f8fafc;
  border-bottom: 1px solid #e8edf2; min-height: 52px; gap: 12px;
}

.table-title { font-size: 14px; font-weight: 700; color: #023449; letter-spacing: -0.01em; }
.table-count { font-size: 11px; color: #94a3b8; font-weight: 600; background: #e8edf2; padding: 2px 8px; border-radius: 10px; }

/* ═══════════════════════════════════════════════════════
   BOTÕES GLOBAIS (na barra de tabs)
═══════════════════════════════════════════════════════ */
.btn-txt {
  text-transform: none !important; letter-spacing: normal !important;
  font-size: 12px !important; font-weight: 700 !important;
  background: rgba(255,255,255,0.12) !important;
  color: #7dd3e8 !important;
  border: 1px solid rgba(255,255,255,0.2) !important;
  border-radius: 6px !important; height: 30px !important; padding: 0 10px !important;
  box-shadow: none !important; transition: all 0.18s !important;
}

.btn-txt:hover {
  background: rgba(255,255,255,0.2) !important;
  color: #bae6fd !important;
}

.btn-excel-wrap >>> .v-btn {
  height: 30px !important; font-size: 12px !important; font-weight: 600 !important;
  text-transform: none !important; letter-spacing: normal !important;
  padding: 0 10px !important; box-shadow: none !important;
}

/* ═══════════════════════════════════════════════════════
   BOTÃO COLUNAS (na toolbar da aba Vendedores)
═══════════════════════════════════════════════════════ */
.btn-colunas {
  text-transform: none !important; letter-spacing: normal !important;
  font-size: 12px !important; font-weight: 600 !important;
  border-color: #d1dae2 !important; color: #4a6274 !important;
  border-radius: 8px !important; height: 32px !important; transition: all 0.18s !important;
}

.btn-colunas:hover {
  border-color: var(--brand) !important; color: var(--brand) !important;
  background: var(--brand-light) !important;
}

/* ═══════════════════════════════════════════════════════
   MENU DE COLUNAS
═══════════════════════════════════════════════════════ */
.colunas-menu-card {
  border-radius: 12px !important; overflow: hidden;
  border: 1px solid #e2eaf0 !important;
  box-shadow: 0 8px 32px rgba(2,52,73,0.14) !important;
}

.colunas-menu-header {
  display: flex; align-items: center; padding: 12px 16px;
  background: linear-gradient(135deg, #023449 0%, #0a4d6a 100%);
  font-size: 12px; font-weight: 700; color: #ffffff;
}

.btn-restaurar {
  text-transform: none !important; letter-spacing: normal !important;
  font-size: 11px !important; font-weight: 600 !important;
  color: rgba(255,255,255,0.75) !important;
}

.btn-restaurar:hover { color: #ffffff !important; }

.colunas-grupo-label {
  display: flex; align-items: center; padding: 10px 16px 3px;
  font-size: 10px; font-weight: 800; text-transform: uppercase;
  letter-spacing: 0.1em; color: #94a3b8;
}

.coluna-item { padding: 1px 16px 1px 20px; }
.coluna-switch { margin: 0 !important; }
.coluna-switch >>> .v-label { font-size: 13px !important; color: #334155 !important; font-weight: 500 !important; }

/* ═══════════════════════════════════════════════════════
   RESUMO CONVENIOS
═══════════════════════════════════════════════════════ */
.convenios-resumo {
  display: flex; align-items: center;
  padding: 12px 20px; background: #f0f9ff;
  border-bottom: 1px solid #bae6fd;
}

.resumo-item { display: flex; flex-direction: column; padding: 0 20px; }
.resumo-item:first-child { padding-left: 0; }
.resumo-label { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: #94a3b8; margin-bottom: 2px; }
.resumo-valor { font-size: 18px; font-weight: 700; color: #0369a1; }
.resumo-valor-destaque { color: #023449; font-size: 20px; }
.resumo-divider { width: 1px; height: 36px; background: #bae6fd; flex-shrink: 0; }

/* ═══════════════════════════════════════════════════════
   LINHAS DE CONVENIO — expandível
═══════════════════════════════════════════════════════ */
.convenio-row { cursor: pointer; transition: background-color 0.12s; }
.convenio-row:hover td { background-color: #e0f2fe !important; }
.convenio-row-expanded td { background-color: #e0f2fe !important; }

.convenio-expand-cell { width: 48px !important; padding: 0 8px !important; }

.icon-expanded  { transform: rotate(90deg);  transition: transform 0.2s cubic-bezier(0.4,0,0.2,1); }
.icon-collapsed { transform: rotate(0deg);   transition: transform 0.2s cubic-bezier(0.4,0,0.2,1); }

.convenio-detail-row td { padding: 0 !important; background: #f0f9ff !important; border-bottom: 2px solid #bae6fd !important; }

.convenio-titulos-wrapper { padding: 12px 16px 16px 48px; }

.convenio-titulos-header {
  display: flex; align-items: center;
  font-size: 11px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.06em; color: #0369a1; margin-bottom: 8px;
}

.titulos-table { border: 1px solid #bae6fd; border-radius: 8px; overflow: hidden; }

.titulos-table >>> thead tr th {
  font-size: 9px !important; font-weight: 800 !important;
  text-transform: uppercase !important; letter-spacing: 0.08em !important;
  color: #0369a1 !important; background: #e0f2fe !important;
  padding: 7px 12px !important; border-bottom: 1px solid #bae6fd !important;
}

.titulo-row td {
  font-size: 12px; color: #1e293b;
  padding: 7px 12px !important; border-bottom: 1px solid #e0f2fe !important;
  background: #ffffff;
}

.titulo-row:last-child td { border-bottom: none !important; }

.titulo-footer td {
  font-size: 12px; background: #e0f2fe !important;
  padding: 8px 12px !important; border-top: 1px solid #bae6fd !important;
}

.venc-atrasado { color: #dc2626; font-weight: 700; }
.venc-proximo  { color: #d97706; font-weight: 700; }
.venc-ok       { color: #475569; }

/* ═══════════════════════════════════════════════════════
   CABEÇALHOS DE GRUPO (linha superior)
═══════════════════════════════════════════════════════ */
.group-header-empty { background: #f0f4f7 !important; border-bottom: none !important; padding: 0 !important; }

.group-header {
  font-size: 9px !important; font-weight: 800 !important; text-transform: uppercase !important;
  letter-spacing: 0.1em !important; text-align: center !important;
  padding: 6px 12px !important; white-space: nowrap;
  border-bottom: 3px solid transparent !important;
}

.gh-vendas      { background: var(--g1-bg) !important; color: var(--g1-text) !important; border-left: 3px solid #d1dae2 !important; border-bottom-color: #d1dae2 !important; }
.gh-percentuais { background: var(--g2-bg) !important; color: var(--g2-text) !important; border-left: 3px solid #d1dae2 !important; border-bottom-color: #d1dae2 !important; }
.gh-comissao    { background: var(--g3-bg) !important; color: var(--g3-text) !important; border-left: 3px solid #d1dae2 !important; border-bottom-color: #d1dae2 !important; }
.gh-bonif       { background: var(--gb-bg) !important; color: var(--gb-text) !important; border-left: 3px solid #d1dae2 !important; border-bottom-color: #d1dae2 !important; }
.gh-salario     { background: var(--g4-bg) !important; color: var(--g4-text) !important; border-left: 3px solid #d1dae2 !important; border-bottom-color: #d1dae2 !important; }
.gh-exportado   { background: var(--brand) !important; color: #7dd3e8 !important;        border-left: 3px solid #d1dae2 !important; border-bottom-color: #d1dae2 !important; }

/* ═══════════════════════════════════════════════════════
   TABELA
═══════════════════════════════════════════════════════ */
.data-table thead tr th {
  font-size: 10px !important; font-weight: 800 !important;
  text-transform: uppercase !important; letter-spacing: 0.07em !important;
  color: #64748b !important; background: #f0f4f7 !important;
  border-bottom: 2px solid #dde4eb !important;
  padding: 11px 14px !important; white-space: nowrap;
}

.data-table thead tr th.sep-grupo { border-left: 3px solid #d1dae2 !important; }
.data-table tbody .data-row td.sep-grupo { border-left: 3px solid #d1dae2 !important; }
.data-table tfoot .data-footer td.sep-grupo { border-left: 3px solid rgba(255,255,255,0.15) !important; }
.sep-left { border-left: 3px solid #d1dae2 !important; }

.data-table tbody .data-row td {
  font-size: 13px; color: #1e293b;
  padding: 10px 14px !important; border-bottom: 1px solid #edf1f5 !important;
  transition: background-color 0.12s ease;
}

.data-table tbody .data-row:nth-child(odd)  td { background-color: #ffffff; }
.data-table tbody .data-row:nth-child(even) td { background-color: #f8fafc; }
.data-table tbody .data-row:hover td { background-color: #eef6fb !important; }

.data-table tfoot .data-footer td {
  font-size: 12px; font-weight: 700; color: #ffffff;
  background: var(--brand) !important;
  border-top: 3px solid #011f2d !important; border-bottom: none !important;
  padding: 12px 14px !important; letter-spacing: 0.01em;
}

/* ═══════════════════════════════════════════════════════
   VALORES SEMÂNTICOS
═══════════════════════════════════════════════════════ */
.value-positive { color: #059669; font-weight: 700; background: rgba(5,150,105,0.08); padding: 2px 6px; border-radius: 4px; }
.value-warning  { color: #d97706; font-weight: 700; background: rgba(217,119,6,0.08); padding: 2px 6px; border-radius: 4px; }
.value-negative { color: #dc2626; font-weight: 700; background: rgba(220,38,38,0.07); padding: 2px 6px; border-radius: 4px; }
.value-zero     { color: #cbd5e1; }

.chip-alerta { border: 1px solid #fbbf24 !important; letter-spacing: 0.01em !important; }

.value-exported { color: var(--brand); font-weight: 700; background: rgba(2,52,73,0.08); padding: 2px 6px; border-radius: 4px; }

/* ═══════════════════════════════════════════════════════
   MISC
═══════════════════════════════════════════════════════ */
.col-first { padding-left: 20px !important; }
.col-last  { padding-right: 20px !important; }

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (max-width: 599px) {
  .results-card { border-radius: 10px; }
  .results-tabs-wrapper { flex-wrap: wrap; padding-right: 8px; }
  .tabs-acoes-globais { width: 100%; padding: 6px 0 8px; border-top: 1px solid rgba(255,255,255,0.1); }
  .meta-bar { padding: 6px 12px; gap: 6px; }
  .table-toolbar { padding: 10px 14px; }
  .convenios-resumo { flex-wrap: wrap; gap: 12px; }
  .resumo-divider { display: none; }
}

@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after { animation-duration: 0.01ms !important; transition-duration: 0.01ms !important; }
}
</style>